import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import './Home.css';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <Navbar />
      
      <div className="home-hero-compact">
        <div className="hero-content-compact">
          <h1>Klinik Management System</h1>
          <p>Access Your Portal</p>
        </div>
      </div>

      <div className="login-section">
        <div className="login-options">
          <div className="login-card" onClick={() => navigate('/admin-login')}>
            <div className="card-icon admin-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h3>Administration</h3>
            <p>Manage clinics, users, and system settings</p>
            <div className="card-arrow">→</div>
          </div>

          <div className="login-card" onClick={() => navigate('/clinic-login')}>
            <div className="card-icon staff-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="8.5" cy="7" r="4"/>
                <polyline points="17 11 19 13 23 9"/>
              </svg>
            </div>
            <h3>Healthcare Staff</h3>
            <p>Doctors, pharmacy, and laboratory portal</p>
            <div className="card-arrow">→</div>
          </div>

          <div className="login-card" onClick={() => navigate('/patient-login')}>
            <div className="card-icon patient-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h3>Patient Portal</h3>
            <p>View prescriptions and book appointments</p>
            <div className="card-arrow">→</div>
          </div>
        </div>
      </div>

      <footer className="home-footer">
        <div className="footer-content">
          <p>&copy; 2025 Klinik. All rights reserved.</p>
          <div className="footer-links">
            <a href="https://klinik.co.in#privacy">Privacy Policy</a>
            <a href="https://klinik.co.in#terms">Terms of Service</a>
            <a href="https://klinik.co.in#contact">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;